import { render } from "./RamadanPopup.vue?vue&type=template&id=353db070&scoped=true"
import script from "./RamadanPopup.vue?vue&type=script&lang=js"
export * from "./RamadanPopup.vue?vue&type=script&lang=js"

import "./RamadanPopup.vue?vue&type=style&index=0&id=353db070&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353db070"]])

export default __exports__